import * as type from '@app/constants/scenes/timers/timersForScenes'

export const syncTimersForScenes = () => ({
  type: type.SYNC_TIMERS_FOR_SCENES,
} as const)
